import axios from 'axios';
import { useAppCache } from '../context/AppCacheContext';

export interface Recipe {
    id: string;
    recipe_id: string;
    user_id: string;
    type: 'recipe';
    recipe_name: string;
    description: string;
    ingredients: string[];
    instructions: string[];
    cuisine: string;
    diet_type: string;
    meal_type: string;
    tried: boolean;
    servings: string;
    prep_time: string;
    cook_time: string;
    total_time: string;
    nutrition_info: string;
    average_rating?: string;
    rating_count?: number;
    createdBy: string;
    establishment_type: string;
    location: string;
    user_ratings?: {
      [key: string]: number;
    };
    
  }



const CACHE_KEY = 'allRecipes';
const API_URL = 'https://dw1271o3wa.execute-api.us-east-1.amazonaws.com/v1/tablefields';

export const useRecipeService = () => {
    const { getCache, setCache } = useAppCache();

    const fetchRecipes = async (): Promise<{ recipes: Recipe[], fromCache: boolean }> => {
        const cachedRecipes = getCache(CACHE_KEY) as Recipe[] | null;
        if (cachedRecipes && cachedRecipes.length > 0) {
            return { recipes: cachedRecipes, fromCache: true };
        }

        try {
            const response = await axios.post(API_URL, {
                entity: 'RecipeTable',
                action: 'scan',
                limit: 1000,
                projection_expression: 'recipe_id, recipe_name, description, meal_type, cuisine, diet_type, created_by',
            }, { headers: { 'Content-Type': 'application/json' } });

            const parsedResponse = JSON.parse(response.data.body);
            const fetchedRecipes = parsedResponse.data || [];

            if (fetchedRecipes.length > 0) {
                setCache(CACHE_KEY, fetchedRecipes);
            }

            return { recipes: fetchedRecipes, fromCache: false };
        } catch (error) {
            console.error('Error fetching recipes:', error);
            throw new Error('Failed to fetch recipes. Please try again later.');
        }
    };

    const invalidateCache = () => setCache(CACHE_KEY, null);

    const getRecipeById = (recipeId: string): Recipe | undefined => {
        const cachedRecipes = getCache(CACHE_KEY) as Recipe[] | null;
        return cachedRecipes?.find(recipe => recipe.recipe_id === recipeId);
    };

    return { fetchRecipes, invalidateCache, getRecipeById };
};